import React from "react";

export default function PageLoader({ message = "Loading..." }) {
  return (
    <div
      className="page-loader d-flex align-items-center justify-content-center"
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255,255,255,0.85)",
        zIndex: 9999,
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-2" role="status" aria-hidden="true" />
        <div className="small text-muted">{message}</div>
      </div>
    </div>
  );
}
